import {createIcon} from '@chakra-ui/icons';

export const DashboardIcon = createIcon({
  displayName: 'DashboardIcon',
  viewBox: '0 0 25 25',
  path: (
    <>
      <rect x='3.5' y='2.5' width='9' height='10.5' rx='2' fill='#FCD673' />
      <rect x='14.5' y='2.5' width='9' height='7.5' rx='2' fill='#5EB5AB' />
      <rect x='3.5' y='15' width='9' height='7.5' rx='2' fill='#FA704D' />
      <rect x='14.5' y='12' width='9' height='10.5' rx='2' fill='white' />
    </>
  ),
});
